// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectFloorNumberingSchemeQueryResult, selectFloorNumberingSchemesPageLoading, selectFloorNumberingSchemesShowInitWaitingMessage} from '../_selectors/floor-numbering-scheme.selectors';

export class FloorNumberingSchemesDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectFloorNumberingSchemesPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectFloorNumberingSchemesShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectFloorNumberingSchemeQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
